<template>
    <v-menu
        v-model="show"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
    >
        <div class="item-container">
            <template v-for="(item, index) in itemList">
                <v-layout @click="select(item)" :key="index" v-if="item.visible" class="item" :id="item.code"
                          align-center>
                    <div class="display-flex align-center justify-center" style="width: 32px">
                        <img :src="item.icon" alt="icon" :style="{transform: `scale(${item.scale})`}" class="mr-2">
                    </div>
                    {{ item.title }}
                </v-layout>
            </template>
        </div>
    </v-menu>
</template>

<script>
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";

const {NodeContextMenuCode, NodeType, NodeIconMap} = ScenarioService

export default {
    name: "ScenarioNodeContextMenu",
    data() {
        const itemList = [
            {
                title: 'Add Bot says',
                code: NodeContextMenuCode.ADD_PROCESS,
                icon: NodeIconMap[NodeType.PROCESS],
                scale: 1.3
            },
            {
                title: 'Add Branch',
                code: NodeContextMenuCode.ADD_DECISION,
                icon: NodeIconMap[NodeType.DECISION],
                scale: 1.1
            },
            {
                title: 'Add Fallback',
                code: NodeContextMenuCode.ADD_FALLBACK,
                icon: '/img/scenario/fallback.svg',
                scale: 1.1
            },
            {
                title: 'Add Supporter',
                code: NodeContextMenuCode.ADD_SUPPORTER,
                icon: NodeIconMap[NodeType.SUPPORTER],
                scale: 0.75
            },
            {
                title: 'Copy Step',
                code: NodeContextMenuCode.COPY_STEP,
                icon: '/img/scenario/copy_blue_2.svg',
                scale: 0.85
            },
            {
                title: 'Paste Step',
                code: NodeContextMenuCode.PASTE_STEP,
                icon: '/img/scenario/paste_blue.svg',
                scale: 0.85
            },
            {
                title: 'Link to Node',
                code: NodeContextMenuCode.LINK_TO,
                icon: '/img/scenario/link.svg',
                scale: 1.3
            },
            {
                title: 'Link to Bot',
                code: NodeContextMenuCode.LINK_TO_SCENARIO,
                icon: '/img/scenario/link.svg',
                scale: 1.3
            },
            {
                title: 'Unlink',
                code: NodeContextMenuCode.UNLINK,
                icon: '/img/scenario/link.svg',
                scale: 1.3
            },
            {
                title: 'Focus',
                code: NodeContextMenuCode.FOCUS_NODE,
                icon: '/img/scenario/focus.svg',
                scale: 1.05
            },
            // {
            //     title: 'Add KB Node',
            //     code: NodeContextMenuCode.KB_NODE,
            //     icon: '/img/scenario/focus.svg',
            //     scale: 1.05
            // },
            {
                title: 'Delete',
                code: NodeContextMenuCode.DELETE,
                icon: '/img/scenario/delete_red.svg',
                scale: 0.9
            },
        ]
        let mapTypeToIndex = {}
        for (let i in itemList) {
            mapTypeToIndex[itemList[i].code] = i
        }
        return {
            show: false,
            x: 0,
            y: 0,
            itemList: itemList,
            mapTypeToIndex: mapTypeToIndex,
            node: null
        }
    },
    computed: {
        ...mapState({
            treeData: state => state.scenario.treeData,
            exceptionMap: state => state.scenario.exceptionMap,
            nodeMap: state => state.scenario.nodeMap
        })
    },
    methods: {
        async open(node, coordinate, isEdit) {
            this.node = node
            this.x = coordinate.x
            this.y = coordinate.y
            this.clearVisibleMenu()
            if (isEdit) {
                await this.updateMenu()
            }
            if (!isEdit && this.node.type === NodeType.PROCESS) {
                for (let item of this.itemList) {
                    item.visible = [NodeContextMenuCode.COPY_STEP, NodeContextMenuCode.FOCUS_NODE].includes(item.code)
                }
            }
            this.show = true
        },
        async updateMenu() {
            let menu
            switch (this.node.type) {
                case NodeType.DECISION:
                    menu = await this.getDecisionMenu()
                    break
                case NodeType.PROCESS:
                    menu = await this.getProcessMenu()
                    break
                case NodeType.PORTAL:
                    menu = this.getPortalMenu()
                    break
                case NodeType.KB:
                    menu = this.getKbMenu()
                    break
                default:
                    menu = this.getPortalMenu()
            }
            for (let item of this.itemList) {
                item.visible = menu.includes(item.code)
            }
            this.$forceUpdate()
        },
        clearVisibleMenu() {
            for (let item of this.itemList) {
                item.visible = false
            }
        },
        select(item) {
            this.show = false
            this.$emit('select', item.code)
        },
        shouldAddProcess() {
            let node = this.node
            if (node.children) {
                return node.children.length === 0
            }
            return true
        },
        shouldAddDecision() {
            let node = this.node
            if (node.children && node.children.length > 0) {
                let firstChild = this.treeData.nodeList.find(item => item.id === node.children[0])
                return firstChild.type === NodeType.DECISION
            }
            return true
        },
        shouldAddFallback() {
            let node = this.node
            if (node.children && node.children.length > 0) {
                let firstChild = this.treeData.nodeList.find(item => item.id === node.children[0])
                if (firstChild.type === NodeType.DECISION) {
                    for (let childId of node.children) {
                        let child = this.treeData.nodeList.find(item => item.id === childId)
                        if (child.is_fallback) {
                            return false
                        }
                    }
                    return true
                }
                return false
            }
            return true
        },
        shouldAddLinkTo() {
            let shouldAddLinkTo = false
            switch (this.node.type) {
                case NodeType.PROCESS:
                    shouldAddLinkTo =
                        this.node.children.length === 0 ||
                        this.nodeMap[this.node.children[0]].type === NodeType.DECISION
                    break
                case NodeType.DECISION:
                    shouldAddLinkTo = this.node.children.length === 0
                    break
                case NodeType.KB:
                    shouldAddLinkTo = this.node.children.length === 0
                    break
                default:
                    shouldAddLinkTo = false
            }
            return shouldAddLinkTo
        },
        shouldAddSupporter() {
            return this.node.children.length === 0
        },
        shouldAddLinkToScenario() {
            return this.node.type === NodeType.PROCESS || this.node.type === NodeType.DECISION || this.node.type == NodeType.KB
        },
        shouldAddKbNode() {
            let node = this.node
            if (node.children) {
                return node.children.length === 0
            }
            return true
        },
        isHaveStepCopied(dataCopied) {
            if (!dataCopied) {
                return false
            }
            try {
                let data = JSON.parse(dataCopied)
                return data.id && data.scenario && data.type === NodeType.PROCESS
            } catch {
                return false
            }
        },
        async getDecisionMenu() {
            let list = this.getCommonMenu()
            // validate clipboard
            let dataCopied = await this.$utils.getDataClipboard()
            if (this.isHaveStepCopied(dataCopied) && this.node.children.length === 0) {
                list.push(NodeContextMenuCode.PASTE_STEP)
            }
            return list
        },
        async getProcessMenu() {
            let list = this.getCommonMenu()
            list.push(NodeContextMenuCode.FOCUS_NODE, NodeContextMenuCode.COPY_STEP)
            // add option delete node for process node
            if (!list.includes(NodeContextMenuCode.DELETE) && this.node.id != this.treeData.startId) {
                list.push(NodeContextMenuCode.DELETE)
            }
            // validate clipboard
            let dataCopied = await this.$utils.getDataClipboard()
            if (this.isHaveStepCopied(dataCopied) && this.node.children.length === 0) {
                list.push(NodeContextMenuCode.PASTE_STEP)
            }
            if (this.shouldAddDecision()) {
                list.push(NodeContextMenuCode.ADD_DECISION)
            }
            if (this.shouldAddFallback()) {
                list.push(NodeContextMenuCode.ADD_FALLBACK)
            }
            return list
        },
        getPortalMenu() {
            return [NodeContextMenuCode.DELETE]
        },
        getKbMenu() {
            let list = this.getCommonMenu()
            list.push(NodeContextMenuCode.FOCUS_NODE)
            if (this.shouldAddDecision()) {
                list.push(NodeContextMenuCode.ADD_DECISION)
            }
            if (this.shouldAddFallback()) {
                list.push(NodeContextMenuCode.ADD_FALLBACK)
            }
            return list
        },
        getCommonMenu() {
            let list = []
            if (this.shouldAddProcess()) {
                list.push(NodeContextMenuCode.ADD_PROCESS)
                list.push(NodeContextMenuCode.ADD_FORM)
            }
            // if (this.shouldAddKbNode()) {
            //     list.push(NodeContextMenuCode.KB_NODE)
            // }
            if (this.shouldAddSupporter()) {
                list.push(NodeContextMenuCode.ADD_SUPPORTER)
            }
            if (this.shouldAddLinkTo()) {
                list.push(NodeContextMenuCode.LINK_TO)
            }
            if (this.shouldAddLinkToScenario()) {
                list.push(NodeContextMenuCode.LINK_TO_SCENARIO)
            }
            if (this.node.id !== this.treeData.startId && this.node.children.length === 0) {
                list.push(NodeContextMenuCode.DELETE)
            }
            if (this.node.children.length > 0) {
                list.push(NodeContextMenuCode.UNLINK)
            }
            return list
        }
    }
}
</script>

<style scoped lang="scss">
.item-container {
    background: #fff;
}

.item {
    font-size: 14px;
    color: #16171D;
    border-bottom: 1px solid #EDEDF2;
    padding: 10px;
    cursor: pointer;

    &:hover {
        background: #E6F4FF;
    }
}

#DELETE {
    color: red;
    border-bottom: none;

    &:hover {
        background: #ffdcdc;
    }
}
</style>
